// extracted by mini-css-extract-plugin
export var attribution = "_96-4";
export var authorName = "_96-5";
export var quote = "_96-3";
export var testimonial = "_96-2";
export var trustedBy = "_96-0";
export var trustedByLabel = "_96-1";